/* Keep the unassigned editorial preview selected when native variants change. */
const jacuEditorialPreview = new URL(window.location.href).searchParams.get('view') === 'editorial';
document.addEventListener('variant:change', () => {
  if (!jacuEditorialPreview || !document.body.classList.contains('je-product-page')) return;
  const url = new URL(window.location.href);
  url.searchParams.set('view', 'editorial');
  window.history.replaceState(window.history.state, '', url);
});

// The theme moves popup contents outside their owner. Close only that owner.
document.addEventListener('click', (event) => {
  if (!document.body.classList.contains('je-product-page')) return;
  const close = event.target.closest('.product-popup-modal__content [id^="ModalClose-"]');
  if (!close) return;
  const owner = document.getElementById(close.id.replace('ModalClose-', 'PopupModal-'));
  if (!owner || !owner.hasAttribute('open') || typeof owner.hide !== 'function') return;
  event.preventDefault();
  event.stopImmediatePropagation();
  owner.hide();
}, true);
document.querySelectorAll('.product-popup-modal__content [id^="ModalClose-"]').forEach(button => {
  button.setAttribute('aria-label', 'Close');
});
